import icons from './icons';

export { default as icons } from './icons';
export default icons;
